import logger from './logger'
import Option from './option'

function getTestgroup() {
  try {
    const option = new Option('_8select_cse_config')
    let testgroup
    let testgroupFromConfig = option.get('testgroup')
    let testgroupFromHook
    // allow to override the testgroup via a hook, for example to sync it with the AB testing tool of the shop
    if (typeof window._8select.config.hooks.getTestgroup === 'function') {
      testgroupFromHook = window._8select.config.hooks.getTestgroup()
    }

    // only override testgroup if is actually is set
    if (testgroupFromHook !== undefined) {
      testgroup = testgroupFromHook
    } else {
      testgroup = testgroupFromConfig
    }

    if (testgroup === undefined) {
      testgroup = Math.floor(Math.random() * 100 + 1)
      option.set('testgroup', testgroup)
    }

    return testgroup
  } catch (error) {
    logger('could not determine testgroup - fallback to control variant', { error })
    // in case of any error just put the user in the control group
    return 1
  }
}

export default getTestgroup
